import { API, retryRequest } from 'src/services'
import { freezeItems } from './freezeItems'

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false
  },
  getters: {},
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ commit }) {
      commit('loading', true)
      const result = await retryRequest(API.region.get)
      commit('saveItems', result.body.success)
    }
  }
}
